<script lang="ts">
	import { slide } from 'svelte/transition';
	import Icon from '../elements/Icon.svelte';
	import { attrValue } from '../utils/html';
	import type { ComponentType } from '../types/props';

	export let customToggle: ComponentType | null = null;
	export let classNames: string = '';
	export let isOpen = false;

	const toggle = () => (isOpen = !isOpen);
</script>

<div class={attrValue([classNames])}>
	<div
		class="header {isOpen ? 'pb-4' : ''} h-[100%]"
		class:cursor-pointer={!customToggle}
		on:click={() => !customToggle && toggle()}
	>
		<slot name="header">Provide an header slot</slot>
		<div
			class="inline-flex items-center flex-shrink-0"
			class:cursor-pointer={customToggle}
			on:click={() => customToggle && toggle()}
		>
			{#if customToggle}
				<svelte:component this={customToggle.component} {...customToggle.props} />
			{:else}
				<div class={attrValue(['arrow', isOpen ? 'open' : ''])}>
					<Icon name="keyboard_arrow_down" size="small" />
				</div>
			{/if}
		</div>
	</div>
	{#if isOpen}
		<div in:slide={{ duration: 200 }} out:slide={{ duration: 200 }}>
			<slot name="content" {...$$restProps}>
				<p>Provide a content slot</p>
			</slot>
		</div>
	{/if}
</div>

<style lang="postcss">
	.header {
		@apply flex items-center gap-3 justify-between w-full select-none font-bold;
	}

	.arrow {
		transition: 200ms ease all;
	}

	.arrow.open {
		transform: rotate(-180deg);
	}
</style>
